import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteDestinationById, deleteHotelCityById, fetchDestinationsList, fetchHotelCityList} from '../../services/userservice';


export const fetchDestinations = createAsyncThunk(
    'destinations/fetch',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchDestinationsList();
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchSeoHotelCity = createAsyncThunk(
    'seoHotelCity/fetch',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchHotelCityList();
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const deleteDestination = createAsyncThunk(
    'destinations/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await deleteDestinationById(id);
            if (response.status === 200 || response.status === 204) {
                return id;
            } else {
                return rejectWithValue("Failed to delete destination.");
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const deleteHotelCity = createAsyncThunk(
    'destinations/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await deleteHotelCityById(id);
            if (response.status === 200 || response.status === 204) {
                return id;
            } else {
                return rejectWithValue("Failed to delete destination.");
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const destinationSlice = createSlice({
    name: 'destinations',
    initialState: {
        destinations: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Other reducers can go here if needed
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDestinations.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDestinations.fulfilled, (state, action) => {
                state.destinations = action.payload;
                state.loading = false;
            })
            .addCase(fetchDestinations.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // seo city hotel
            .addCase(fetchSeoHotelCity.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSeoHotelCity.fulfilled, (state, action) => {
                state.destinations = action.payload;
                state.loading = false;
            })
            .addCase(fetchSeoHotelCity.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Delete destination
            .addCase(deleteDestination.fulfilled, (state, action) => {
                state.destinations = state.destinations.filter(
                    (destination) => destination.id !== action.payload
                );
            })
            .addCase(deleteDestination.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

export default destinationSlice.reducer;
